module.exports = __webpack_public_path__ + "img/image-1.41c75aa5.png";